import { Box } from "@mui/material";
import { UserLayout } from "../UserLayout";
import {
  TeamActivityDetailSection,
  TeamActivityHeaderSection,
} from "../../../modules";

export const TeamActivity = () => {
  return (
    <UserLayout>
      <Box paddingTop="1rem">
        <TeamActivityHeaderSection />
      </Box>
      <TeamActivityDetailSection />
    </UserLayout>
  );
};
